import { j as r } from "./atoms-v218.js";
import { ThemeProvider as m } from "styled-components";
import { Tokens as s } from "./atoms-v257.js";
const t = new s(), a = ({
  children: e,
  theme: o = t
}) => /* @__PURE__ */ r.jsx(m, { theme: o, children: e });
export {
  a as AtomsThemeProvider,
  t as DefaultLayersTheme
};
